import { render, staticRenderFns } from "./YesAlert.vue?vue&type=template&id=558c6a54&scoped=true&"
import script from "./YesAlert.vue?vue&type=script&lang=js&"
export * from "./YesAlert.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "558c6a54",
  null
  
)

export default component.exports